<script setup lang="ts">
/**
 * MSVplus Enterprise - Auth Layout
 *
 * Dieses Layout wird für öffentliche Seiten verwendet,
 * die keine Authentifizierung erfordern (z.B. Login-Seite).
 *
 * @version 1.0.0
 * @author MiniMax Agent
 */
</script>

<template>
  <div class="auth-layout">
    <!-- Hauptinhalt -->
    <main class="auth-main">
      <slot />
    </main>
  </div>
</template>

<style scoped>
/**
 * Auth Layout Container
 */
.auth-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
}

/**
 * Hauptinhalt
 */
.auth-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
